import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

// All translations - SEO optimized
const translations = {
  tr: {
    // Navbar
    nav: {
      services: "HİZMETLER",
      venue: "MEKAN",
      about: "HAKKIMIZDA",
      gallery: "GALERİ",
      contact: "İLETİŞİM",
      reservation: "REZERVASYON"
    },
    // Media Gallery
    media: {
      subtitle: "Medya Galerisi",
      title1: "GÖRSEL &",
      title2: "VİDEOLAR",
      desc: "First Lady Night Club'dan özel kareler ve videolar",
      all: "Tümü",
      images: "Görseller",
      videos: "Videolar"
    },
    // Hero Section - SEO Heavy
    hero: {
      urgencyBanner: "Bu Gece Sınırlı Kapasite!",
      location: "Girne • Kyrenia • North Cyprus",
      title1: "KONSOMATRİS",
      title2: "& DANSÖZ",
      title3: "HİZMETLERİ",
      subtitle: "Kuzey Kıbrıs'ın #1 Yetişkin Eğlence Hizmeti. Otel, villa, rezidans ve evinize profesyonel konsomatris ve dansöz. Girne'de direk dansı ve striptiz showları. VIP taksi ve transfer 7/24.",
      trustSignal1: "4.9/5 Puan",
      trustSignal2: "50.000+ Misafir",
      trustSignal3: "10+ Yıl Tecrübe",
      feature1: "Otel/Villa Servisi",
      feature2: "VIP Transfer",
      feature3: "7/24 Açık",
      ctaWhatsapp: "Hemen Rezervasyon",
      ctaCall: "Hemen Ara",
      available: "7/24 WhatsApp & Telefon",
      onlineNow: "Şu an çevrimiçi - 5 dakikada yanıt garantisi",
      discover: "Keşfet"
    },
    // Services Section - SEO Focused
    services: {
      subtitle: "Premium Hizmetler",
      title1: "VIP",
      title2: "HİZMETLER",
      description: "Kuzey Kıbrıs'ta otel, villa, rezidans ve evinize özel konsomatris, dansöz ve VIP transfer hizmetleri. Tam gizlilik garantisi ile profesyonel hizmet.",
      stat1: "Yıllık Deneyim",
      stat2: "Mutlu Misafir",
      stat3: "Yıldız Hizmet",
      // Highlighted Service - HOTEL/VILLA
      highlightedTitle: "Otel, Villa & Rezidans Hizmeti",
      highlightedDesc: "Kuzey Kıbrıs'ın en prestijli otel, villa ve rezidans servisi. Konumunuza özel konsomatris ve dansöz hizmeti. Evinize, lüks otelinize, özel villanıza veya rezidansınıza profesyonel eğlence hizmeti. TAM GİZLİLİK ve GÜVENLİK garantisi. Girne, Lefkoşa, Gazimağusa ve tüm Kuzey Kıbrıs'a 7/24 servis.",
      highlightedFeatures: ["Otel Hizmeti", "Villa Hizmeti", "Rezidans Hizmeti", "Ev Hizmeti", "7/24 Hizmet", "Tam Gizlilik"],
      mostPopular: "#1 En Popüler",
      // Service Cards
      service1Title: "Konsomatris Hizmeti",
      service1Desc: "Kıbrıs'ın en seçkin ve profesyonel konsomatris bayanları. Otel odanıza, villanıza veya evinize özel VIP hizmet. Girne, Lefkoşa, Gazimağusa'ya servis. Tam gizlilik garantisi.",
      service1Features: ["Profesyonel Kadro", "Otel Servisi", "Villa Servisi", "Tam Gizlilik"],
      service2Title: "Dansöz & Oryantal",
      service2Desc: "Profesyonel dansöz ve oryantal dans hizmeti. Bekarlığa veda, doğum günü, özel parti ve kutlamalar için. Otel, villa, rezidans ve mekanınıza geliyoruz.",
      service2Features: ["Oryantal Dans", "Bekarlığa Veda", "Doğum Günü", "Özel Parti"],
      service3Title: "VIP Taksi & Transfer",
      service3Desc: "Ercan Havalimanı, otel ve mekanlar arası lüks Mercedes ve BMW araçlarla 7/24 VIP transfer. Profesyonel şoförler, sigortalı araçlar.",
      service3Features: ["Havalimanı Transfer", "Otel Transfer", "Lüks Araçlar", "7/24 Hizmet"],
      bookNow: "Şimdi Rezervasyon",
      callNow: "Hemen Ara",
      seoText: "First Lady - Kuzey Kıbrıs'ın #1 yetişkin eğlence hizmeti. Girne, Lefkoşa, Gazimağusa otellerine, villalarına ve rezidanslarına konsomatris ve dansöz. Profesyonel VIP transfer. 10+ yıllık tecrübe, 50.000+ mutlu misafir. Kıbrıs konsomatris, Girne dansöz, otel hizmeti Kıbrıs, villa hizmeti KKTC."
    },
    // Venue Section - NIGHTCLUB
    venue: {
      subtitle: "First Lady Club",
      title1: "GİRNE'NİN",
      title2: "#1 CLUB'I",
      description: "Kuzey Kıbrıs'ın en prestijli yetişkin eğlence mekanı. Profesyonel direk dansı showları, striptiz performansları ve VIP masa hizmeti. Girne merkeze 5 dakika.",
      feature1Title: "Direk Dansı Showları",
      feature1Desc: "Kıbrıs'ın en profesyonel dansçıları ile nefes kesen pole dance performansları",
      feature2Title: "Striptiz Performansları",
      feature2Desc: "Yetişkin eğlence sektörünün en kaliteli ve profesyonel showları",
      feature3Title: "VIP Masa & Şişe Servisi",
      feature3Desc: "Özel VIP alanlar, premium şişe servisi, kişisel host hizmeti",
      feature4Title: "Canlı DJ & Müzik",
      feature4Desc: "Her gece farklı konsept, profesyonel DJ performansları, dans pisti",
      ctaTitle: "First Lady Club'a Gel",
      ctaDesc: "Girne'nin en iyi gece kulübünde unutulmaz bir gece için VIP masa rezervasyonu yap. 7/24 WhatsApp hattımız açık.",
      ctaWhatsapp: "Masa Rezervasyonu",
      ctaCall: "Hemen Ara",
      hours: "7/24 Açık",
      seoText: "First Lady Club Girne - Kuzey Kıbrıs'ın #1 gece kulübü. Direk dansı, striptiz, pole dance showları. VIP masa rezervasyonu. Kıbrıs gece kulübü, Girne night club, KKTC eğlence mekanı, Cyprus nightclub."
    },
    // About Section
    about: {
      subtitle: "Hakkımızda",
      title1: "FIRST LADY",
      title2: "ENTERTAINMENT",
      mainTitle: "Kıbrıs'ın #1 Yetişkin Eğlence Markası",
      para1: "First Lady, 2014 yılından bu yana Kuzey Kıbrıs'ta profesyonel yetişkin eğlence hizmeti sunmaktadır. Otel, villa ve rezidanslara konsomatris ve dansöz hizmeti, Girne'deki mekanımızda direk dansı ve striptiz showları ile sektörün lider markasıyız.",
      para2: "50.000'den fazla mutlu misafir, 4.9/5 puan ortalaması ve %90 üzeri tekrar tercih oranı ile Kuzey Kıbrıs'ın en güvenilir yetişkin eğlence hizmetiyiz. Tam gizlilik garantisi ile profesyonel hizmet sunuyoruz.",
      para3: "Profesyonel kadromuz, lüks Mercedes ve BMW araç filomuz, 10 yılı aşkın tecrübemiz ile Girne, Lefkoşa, Gazimağusa ve tüm Kuzey Kıbrıs'a 7/24 hizmet veriyoruz.",
      feature1: "Tam Gizlilik",
      feature2: "Profesyonel Kadro",
      feature3: "Premium Kalite",
      feature4: "7/24 Hizmet",
      stat1: "Yıllık Tecrübe",
      stat2: "Mutlu Misafir",
      stat3: "Puan Ortalaması",
      stat4: "Kesintisiz Hizmet",
      established: "Kuruluş",
      seoText: "First Lady Entertainment - Kuzey Kıbrıs'ın en köklü ve güvenilir yetişkin eğlence markası. 2014'ten beri profesyonel hizmet. Konsomatris, dansöz, VIP transfer, gece kulübü."
    },
    // Contact Section
    contact: {
      subtitle: "İletişim",
      title1: "HEMEN",
      title2: "ARAYIN",
      description: "Konsomatris, dansöz, otel/villa servisi ve VIP transfer için 7/24 WhatsApp",
      phone: "Telefon",
      location: "Konum",
      locationValue: "Girne, Kuzey Kıbrıs",
      hours: "Çalışma Saatleri",
      hoursValue: "7/24 Kesintisiz Hizmet",
      whatsappBtn: "WhatsApp ile Yazın",
      supportTitle: "7/24 Destek Hattı",
      supportDesc: "Anında dönüş garantisi. Girne, Lefkoşa, Gazimağusa ve tüm Kuzey Kıbrıs'a hizmet!"
    },
    // FAQ Section - SEO Rich
    faq: {
      subtitle: "Sık Sorulan Sorular",
      title1: "MERAK",
      title2: "EDİLENLER",
      description: "Hizmetlerimiz hakkında en çok sorulan sorular ve cevapları",
      questions: [
        {
          q: "Kıbrıs'ta otel ve villa hizmeti nasıl çalışıyor?",
          a: "Girne, Lefkoşa, Gazimağusa ve tüm Kuzey Kıbrıs'taki otel odanıza, villanıza veya rezidansınıza profesyonel konsomatris ve dansöz gönderiyoruz. Tam gizlilik garantisi ile 7/24 hizmet. WhatsApp'tan rezervasyon: +90 548 848 4828"
        },
        {
          q: "Hangi bölgelere hizmet veriyorsunuz?",
          a: "Kuzey Kıbrıs'ın tamamına hizmet veriyoruz: Girne (Kyrenia), Lefkoşa (Nicosia), Gazimağusa (Famagusta), Güzelyurt, Karpaz ve tüm turistik bölgeler. VIP transfer ile her yere ulaşım."
        },
        {
          q: "First Lady Club nerede, çalışma saatleri ne?",
          a: "First Lady Club, Girne merkezde yer almaktadır. 7/24 açığız. Direk dansı, striptiz showları ve VIP masa hizmeti sunuyoruz."
        },
        {
          q: "Gizlilik konusunda nasıl bir politikanız var?",
          a: "Müşteri gizliliği en önemli önceliğimizdir. Tüm hizmetlerimiz TAM GİZLİLİK garantisi ile sunulmaktadır. Müşteri bilgileri kesinlikle üçüncü şahıslarla paylaşılmaz."
        },
        {
          q: "Nasıl rezervasyon yapabilirim?",
          a: "WhatsApp üzerinden 7/24 kolay ve hızlı rezervasyon: +90 548 848 4828. Otel/villa servisi, mekan rezervasyonu ve VIP transfer için tek numara. 5 dakikada yanıt garantisi."
        },
        {
          q: "Hangi ödeme yöntemlerini kabul ediyorsunuz?",
          a: "Nakit (Türk Lirası, Euro, Dolar, Sterlin) ve kredi kartı kabul ediyoruz. Ödeme hizmet sonrası alınır."
        },
        {
          q: "Bekarlığa veda partisi için dansöz ayarlayabilir misiniz?",
          a: "Evet! Bekarlığa veda, doğum günü, özel parti ve kutlamalar için profesyonel dansöz ve oryantal hizmeti sunuyoruz. Otel, villa, rezidans veya mekanınıza geliyoruz."
        },
        {
          q: "VIP transfer hizmeti nasıl çalışıyor?",
          a: "Ercan Havalimanı, otel veya belirttiğiniz adresten lüks Mercedes ve BMW araçlarla alıyoruz. Profesyonel şoförler, 7/24 hizmet, sigortalı araçlar."
        }
      ],
      moreQuestions: "Başka sorunuz mu var?",
      whatsappLink: "WhatsApp'tan bize yazın →"
    },
    // Footer
    footer: {
      description: "Kuzey Kıbrıs'ın #1 yetişkin eğlence hizmeti. Otel, villa, rezidansa konsomatris ve dansöz. Direk dansı ve striptiz showları. VIP transfer 7/24.",
      quickLinks: "Hızlı Linkler",
      contact: "İletişim",
      legal: "Yasal Uyarı",
      privacy: "Gizlilik Politikası",
      copyright: "Tüm hakları saklıdır.",
      vipExperience: "VIP Entertainment Services"
    },
    // Floating WhatsApp
    floatingWhatsapp: {
      tooltip: "Hemen Yazın!",
      defaultMessage: "Merhaba, hizmetleriniz hakkında bilgi almak istiyorum."
    },
    // Legal Disclaimer - YASAL UYUMLU
    legal: {
      pageTitle: "Yasal Uyarı",
      shortDisclaimer: "Bu platform, yetişkin eğlence asistanlık hizmeti sunmaktadır. Tüm hizmetler yasalara uygun şekilde, 18 yaş üstü reşit bireyler arasında karşılıklı rıza ile gerçekleştirilmektedir. Sitede yer alan bilgiler sadece tanıtım amaçlıdır.",
      fullDisclaimer: "Bu web sitesi, yetişkin eğlence sektöründe faaliyet gösteren yasal bir platformdur. Sunulan konsomatris, dansöz ve transfer hizmetleri, Kuzey Kıbrıs Türk Cumhuriyeti yasalarına uygun şekilde, 18 yaş ve üzeri reşit bireyler arasında karşılıklı rıza ile gerçekleştirilmektedir. Platform, herhangi bir yasadışı faaliyeti desteklememekte ve teşvik etmemektedir. Hizmetlerimiz sadece 18 yaş ve üzeri bireylere yöneliktir. Kullanıcılar, hizmetlerimizi kullanarak bu koşulları ve 18 yaşından büyük olduklarını kabul etmiş sayılırlar. Müşteri bilgileri gizlilik politikamız kapsamında korunmaktadır.",
      backToHome: "Ana Sayfaya Dön"
    },
    // Testimonials
    testimonials: {
      subtitle: "Müşteri Yorumları",
      title1: "MÜŞTERİ",
      title2: "DENEYİMLERİ",
      description: "50.000+ mutlu misafirin deneyimleri",
      reviews: [
        { name: "Ahmet Y.", location: "İstanbul", text: "Girne'de otel hizmeti için aradım. İnanılmaz profesyonel bir ekip. Gizlilik ve kalite konusunda 10/10. Kesinlikle tavsiye ederim." },
        { name: "Mehmet K.", location: "Ankara", text: "Villa için konsomatris hizmeti aldık. Çok memnun kaldık. First Lady gerçekten Kıbrıs'ın en iyisi." },
        { name: "Can B.", location: "İzmir", text: "Bekarlığa veda partisi için dansöz hizmeti aldık. Muhteşem bir gece oldu! Profesyonel ve eğlenceli." },
        { name: "Emre S.", location: "Bursa", text: "VIP transfer ve mekan rezervasyonu yaptık. Her şey kusursuzdu. 5 yıldızlı hizmet!" }
      ]
    },
    // Gallery
    gallery: {
      subtitle: "Galeri",
      title1: "VIP",
      title2: "DENEYİM",
      description: "First Lady'nin profesyonel hizmetleri ve lüks mekanından kareler"
    },
    // Why Choose Us
    whyChooseUs: {
      subtitle: "Neden First Lady?",
      title1: "NEDEN",
      title2: "FIRST LADY",
      features: [
        { title: "Tam Gizlilik", desc: "Müşteri mahremiyeti #1 önceliğimiz" },
        { title: "7/24 Hizmet", desc: "Gece gündüz her an ulaşılabilir" },
        { title: "Profesyonel Kadro", desc: "Seçkin ve eğitimli personel" },
        { title: "5 Dakika Yanıt", desc: "Anında dönüş garantisi" }
      ]
    }
  },
  en: {
    // Navbar
    nav: {
      services: "SERVICES",
      venue: "VENUE",
      about: "ABOUT",
      gallery: "GALLERY",
      contact: "CONTACT",
      reservation: "BOOKING"
    },
    // Media Gallery
    media: {
      subtitle: "Media Gallery",
      title1: "PHOTOS &",
      title2: "VIDEOS",
      desc: "Exclusive photos and videos from First Lady Night Club",
      all: "All",
      images: "Photos",
      videos: "Videos"
    },
    // Hero Section
    hero: {
      urgencyBanner: "Limited Availability Tonight!",
      location: "Kyrenia • Girne • North Cyprus",
      title1: "HOSTESS",
      title2: "& DANCER",
      title3: "SERVICES",
      subtitle: "North Cyprus' #1 Adult Entertainment Service. Professional hostess and dancer to your hotel, villa, residence. Pole dance and striptease shows in Kyrenia. VIP taxi and transfer 24/7.",
      trustSignal1: "4.9/5 Rating",
      trustSignal2: "50,000+ Guests",
      trustSignal3: "10+ Years Experience",
      feature1: "Hotel/Villa Service",
      feature2: "VIP Transfer",
      feature3: "24/7 Open",
      ctaWhatsapp: "Book Now",
      ctaCall: "Call Now",
      available: "24/7 WhatsApp & Phone",
      onlineNow: "Online now - 5 minute response guarantee",
      discover: "Discover"
    },
    // Services Section
    services: {
      subtitle: "Premium Services",
      title1: "VIP",
      title2: "SERVICES",
      description: "Private hostess, dancer and VIP transfer services to hotels, villas and residences in North Cyprus. Professional service with complete privacy guarantee.",
      stat1: "Years Experience",
      stat2: "Happy Guests",
      stat3: "Star Service",
      highlightedTitle: "Hotel, Villa & Residence Service",
      highlightedDesc: "North Cyprus' most prestigious hotel, villa and residence service. Private hostess and dancer to your location. Professional entertainment to your luxury hotel, private villa or residence. COMPLETE PRIVACY and SECURITY guaranteed. 24/7 service to Kyrenia, Nicosia, Famagusta and all North Cyprus.",
      highlightedFeatures: ["Hotel Service", "Villa Service", "Residence Service", "Home Service", "24/7 Service", "Full Privacy"],
      mostPopular: "#1 Most Popular",
      service1Title: "Hostess Service",
      service1Desc: "Cyprus' most select and professional hostesses. Private VIP service to your hotel room, villa or home. Service to Kyrenia, Nicosia, Famagusta. Complete privacy guarantee.",
      service1Features: ["Professional Staff", "Hotel Service", "Villa Service", "Full Privacy"],
      service2Title: "Dancer & Belly Dance",
      service2Desc: "Professional dancer and belly dance service. For bachelor parties, birthdays, private parties and celebrations. We come to your hotel, villa, residence or venue.",
      service2Features: ["Belly Dance", "Bachelor Party", "Birthday", "Private Party"],
      service3Title: "VIP Taxi & Transfer",
      service3Desc: "24/7 VIP transfer with luxury Mercedes and BMW vehicles between Ercan Airport, hotels and venues. Professional drivers, insured vehicles.",
      service3Features: ["Airport Transfer", "Hotel Transfer", "Luxury Vehicles", "24/7 Service"],
      bookNow: "Book Now",
      callNow: "Call Now",
      seoText: "First Lady - North Cyprus' #1 adult entertainment service. Hostess and dancer to hotels, villas and residences in Kyrenia, Nicosia, Famagusta. Professional VIP transfer. 10+ years experience, 50,000+ happy guests."
    },
    // Venue Section
    venue: {
      subtitle: "First Lady Club",
      title1: "KYRENIA'S",
      title2: "#1 CLUB",
      description: "North Cyprus' most prestigious adult entertainment venue. Professional pole dance shows, striptease performances and VIP table service. 5 minutes from Kyrenia center.",
      feature1Title: "Pole Dance Shows",
      feature1Desc: "Breathtaking pole dance performances by Cyprus' most professional dancers",
      feature2Title: "Striptease Performances",
      feature2Desc: "The highest quality and professional shows in adult entertainment",
      feature3Title: "VIP Table & Bottle Service",
      feature3Desc: "Private VIP areas, premium bottle service, personal host service",
      feature4Title: "Live DJ & Music",
      feature4Desc: "Different concept every night, professional DJ performances, dance floor",
      ctaTitle: "Come to First Lady Club",
      ctaDesc: "Make a VIP table reservation for an unforgettable night at Kyrenia's best nightclub. 24/7 WhatsApp line open.",
      ctaWhatsapp: "Table Reservation",
      ctaCall: "Call Now",
      hours: "Open 24/7",
      seoText: "First Lady Club Kyrenia - North Cyprus' #1 nightclub. Pole dance, striptease shows. VIP table reservation. Cyprus nightclub, Kyrenia night club, TRNC entertainment venue."
    },
    // About Section
    about: {
      subtitle: "About Us",
      title1: "FIRST LADY",
      title2: "ENTERTAINMENT",
      mainTitle: "Cyprus' #1 Adult Entertainment Brand",
      para1: "First Lady has been providing professional adult entertainment services in North Cyprus since 2014. We are the leading brand in the sector with hostess and dancer services to hotels, villas and residences, and pole dance and striptease shows at our venue in Kyrenia.",
      para2: "With over 50,000 happy guests, 4.9/5 average rating and over 90% repeat rate, we are North Cyprus' most trusted adult entertainment service. We provide professional service with complete privacy guarantee.",
      para3: "With our professional team, luxury Mercedes and BMW fleet, over 10 years of experience, we provide 24/7 service to Kyrenia, Nicosia, Famagusta and all North Cyprus.",
      feature1: "Full Privacy",
      feature2: "Professional Team",
      feature3: "Premium Quality",
      feature4: "24/7 Service",
      stat1: "Years Experience",
      stat2: "Happy Guests",
      stat3: "Average Rating",
      stat4: "24/7 Service",
      established: "Established",
      seoText: "First Lady Entertainment - North Cyprus' most established and trusted adult entertainment brand. Professional service since 2014. Hostess, dancer, VIP transfer, nightclub."
    },
    // Contact Section
    contact: {
      subtitle: "Contact",
      title1: "CALL",
      title2: "NOW",
      description: "24/7 WhatsApp for hostess, dancer, hotel/villa service and VIP transfer",
      phone: "Phone",
      location: "Location",
      locationValue: "Kyrenia, North Cyprus",
      hours: "Working Hours",
      hoursValue: "24/7 Service",
      whatsappBtn: "Message on WhatsApp",
      supportTitle: "24/7 Support Line",
      supportDesc: "Instant response guarantee. Service to Kyrenia, Nicosia, Famagusta and all North Cyprus!"
    },
    // FAQ Section
    faq: {
      subtitle: "Frequently Asked Questions",
      title1: "COMMON",
      title2: "QUESTIONS",
      description: "Most frequently asked questions about our services",
      questions: [
        {
          q: "How does hotel and villa service work in Cyprus?",
          a: "We send professional hostess and dancer to your hotel room, villa or residence in Kyrenia, Nicosia, Famagusta and all North Cyprus. 24/7 service with complete privacy guarantee. Book via WhatsApp: +90 548 848 4828"
        },
        {
          q: "Which areas do you serve?",
          a: "We serve all of North Cyprus: Kyrenia (Girne), Nicosia (Lefkoşa), Famagusta (Gazimağusa), Guzelyurt, Karpaz and all tourist areas. Transportation anywhere with VIP transfer."
        },
        {
          q: "Where is First Lady Club, what are the hours?",
          a: "First Lady Club is located in Kyrenia center. Open every day from 4PM to 2AM. We offer pole dance, striptease shows and VIP table service."
        },
        {
          q: "What is your privacy policy?",
          a: "Customer privacy is our #1 priority. All our services are provided with COMPLETE PRIVACY guarantee. Customer information is never shared with third parties."
        },
        {
          q: "How can I make a reservation?",
          a: "Easy and fast 24/7 reservation via WhatsApp: +90 548 848 4828. Single number for hotel/villa service, venue reservation and VIP transfer. 5 minute response guarantee."
        },
        {
          q: "Which payment methods do you accept?",
          a: "We accept cash (Turkish Lira, Euro, Dollar, Sterling) and credit card. Payment is taken after service."
        },
        {
          q: "Can you arrange a dancer for bachelor party?",
          a: "Yes! We provide professional dancer and belly dance service for bachelor parties, birthdays, private parties and celebrations. We come to your hotel, villa, residence or venue."
        },
        {
          q: "How does VIP transfer service work?",
          a: "We pick you up from Ercan Airport, hotel or specified address with luxury Mercedes and BMW vehicles. Professional drivers, 24/7 service, insured vehicles."
        }
      ],
      moreQuestions: "Have more questions?",
      whatsappLink: "Message us on WhatsApp →"
    },
    // Footer
    footer: {
      description: "North Cyprus' #1 adult entertainment service. Hostess and dancer to hotels, villas, residences. Pole dance and striptease shows. VIP transfer 24/7.",
      quickLinks: "Quick Links",
      contact: "Contact",
      legal: "Legal Disclaimer",
      privacy: "Privacy Policy",
      copyright: "All rights reserved.",
      vipExperience: "VIP Entertainment Services"
    },
    // Floating WhatsApp
    floatingWhatsapp: {
      tooltip: "Message Us!",
      defaultMessage: "Hello, I would like information about your services."
    },
    // Legal Disclaimer
    legal: {
      pageTitle: "Legal Disclaimer",
      shortDisclaimer: "This platform provides adult entertainment assistance services. All services are conducted legally, between consenting adults aged 18 and over. Information on this site is for promotional purposes only.",
      fullDisclaimer: "This website is a legal platform operating in the adult entertainment sector. The hostess, dancer and transfer services offered are conducted in accordance with the laws of the Turkish Republic of Northern Cyprus, between consenting adults aged 18 and over. The platform does not support or encourage any illegal activity. Our services are intended only for individuals aged 18 and over. By using our services, users agree to these terms and confirm they are over 18 years of age. Customer information is protected under our privacy policy.",
      backToHome: "Back to Home"
    },
    // Testimonials
    testimonials: {
      subtitle: "Customer Reviews",
      title1: "CUSTOMER",
      title2: "EXPERIENCES",
      description: "Experiences of 50,000+ happy guests",
      reviews: [
        { name: "Ahmet Y.", location: "Istanbul", text: "Called for hotel service in Kyrenia. Incredibly professional team. 10/10 for privacy and quality. Highly recommend." },
        { name: "Mehmet K.", location: "Ankara", text: "Got hostess service for villa. Very satisfied. First Lady is truly Cyprus' best." },
        { name: "Can B.", location: "Izmir", text: "Got dancer service for bachelor party. It was an amazing night! Professional and fun." },
        { name: "Emre S.", location: "Bursa", text: "Made VIP transfer and venue reservation. Everything was perfect. 5 star service!" }
      ]
    },
    // Gallery
    gallery: {
      subtitle: "Gallery",
      title1: "VIP",
      title2: "EXPERIENCE",
      description: "Moments from First Lady's professional services and luxury venue"
    },
    // Why Choose Us
    whyChooseUs: {
      subtitle: "Why First Lady?",
      title1: "WHY",
      title2: "FIRST LADY",
      features: [
        { title: "Full Privacy", desc: "Customer privacy is our #1 priority" },
        { title: "24/7 Service", desc: "Available day and night" },
        { title: "Professional Team", desc: "Select and trained staff" },
        { title: "5 Min Response", desc: "Instant response guarantee" }
      ]
    }
  },
  // HEBREW (HE) - עברית
  he: {
    nav: {
      services: "שירותים",
      venue: "מועדון",
      about: "אודות",
      gallery: "גלריה",
      contact: "צור קשר",
      reservation: "הזמנה"
    },
    media: {
      subtitle: "גלריית מדיה",
      title1: "תמונות &",
      title2: "סרטונים",
      desc: "תמונות וסרטונים בלעדיים מ-First Lady Night Club",
      all: "הכל",
      images: "תמונות",
      videos: "סרטונים"
    },
    hero: {
      urgencyBanner: "קיבולת מוגבלת הלילה!",
      location: "קירניה • גירנה • צפון קפריסין",
      title1: "מארחות",
      title2: "ורקדניות",
      title3: "שירותים",
      subtitle: "שירות הבידור למבוגרים #1 בצפון קפריסין. מארחות ורקדניות מקצועיות למלון, וילה, מגורים שלכם. מופעי ריקוד על עמוד וסטריפטיז בקירניה. מונית VIP והסעות 24/7.",
      trustSignal1: "דירוג 4.9/5",
      trustSignal2: "50,000+ אורחים",
      trustSignal3: "10+ שנות ניסיון",
      feature1: "שירות מלון/וילה",
      feature2: "הסעות VIP",
      feature3: "פתוח 24/7",
      ctaWhatsapp: "הזמינו עכשיו",
      ctaCall: "התקשרו עכשיו",
      available: "WhatsApp וטלפון 24/7",
      onlineNow: "מקוון עכשיו - הבטחת תגובה תוך 5 דקות",
      discover: "גלו"
    },
    services: {
      subtitle: "שירותים פרימיום",
      title1: "שירותי",
      title2: "VIP",
      description: "שירותי מארחות, רקדניות והסעות VIP פרטיים למלונות, וילות ומגורים בצפון קפריסין. שירות מקצועי עם הבטחת פרטיות מלאה.",
      stat1: "שנות ניסיון",
      stat2: "אורחים מרוצים",
      stat3: "שירות כוכבים",
      highlightedTitle: "שירות מלון, וילה ומגורים",
      highlightedDesc: "שירות המלונות, וילות ומגורים היוקרתי ביותר בצפון קפריסין. מארחות ורקדניות פרטיות למיקום שלכם. בידור מקצועי למלון היוקרה, וילה פרטית או מגורים שלכם. פרטיות ואבטחה מלאות מובטחות. שירות 24/7 לקירניה, ניקוסיה, פאמגוסטה וכל צפון קפריסין.",
      highlightedFeatures: ["שירות מלון", "שירות וילה", "שירות מגורים", "שירות בית", "שירות 24/7", "פרטיות מלאה"],
      mostPopular: "#1 הפופולרי ביותר",
      service1Title: "שירות מארחות",
      service1Desc: "המארחות המקצועיות והנבחרות ביותר בקפריסין. שירות VIP פרטי לחדר המלון, וילה או בית שלכם. שירות לקירניה, ניקוסיה, פאמגוסטה. הבטחת פרטיות מלאה.",
      service1Features: ["צוות מקצועי", "שירות מלון", "שירות וילה", "פרטיות מלאה"],
      service2Title: "רקדניות ובטן",
      service2Desc: "שירות רקדניות וריקודי בטן מקצועי. למסיבות רווקים, ימי הולדת, מסיבות פרטיות וחגיגות. אנחנו מגיעים למלון, וילה, מגורים או מקום שלכם.",
      service2Features: ["ריקודי בטן", "מסיבת רווקים", "יום הולדת", "מסיבה פרטית"],
      service3Title: "מונית והסעות VIP",
      service3Desc: "הסעות VIP 24/7 עם רכבי מרצדס ו-BMW יוקרתיים בין נמל התעופה ארקאן, מלונות ומקומות. נהגים מקצועיים, רכבים מבוטחים.",
      service3Features: ["הסעות משדה תעופה", "הסעות מלון", "רכבי יוקרה", "שירות 24/7"],
      bookNow: "הזמינו עכשיו",
      callNow: "התקשרו עכשיו",
      seoText: "First Lady - שירות הבידור למבוגרים #1 בצפון קפריסין. מארחות ורקדניות למלונות, וילות ומגורים בקירניה, ניקוסיה, פאמגוסטה. הסעות VIP מקצועיות. 10+ שנות ניסיון, 50,000+ אורחים מרוצים."
    },
    venue: {
      subtitle: "First Lady Club",
      title1: "המועדון #1",
      title2: "בקירניה",
      description: "מקום הבידור למבוגרים היוקרתי ביותר בצפון קפריסין. מופעי ריקוד על עמוד מקצועיים, הופעות סטריפטיז ושירות שולחן VIP. 5 דקות ממרכז קירניה.",
      feature1Title: "מופעי ריקוד על עמוד",
      feature1Desc: "הופעות ריקוד על עמוד עוצרות נשימה על ידי הרקדניות המקצועיות ביותר בקפריסין",
      feature2Title: "הופעות סטריפטיז",
      feature2Desc: "המופעים האיכותיים והמקצועיים ביותר בבידור למבוגרים",
      feature3Title: "שולחן ובקבוק VIP",
      feature3Desc: "אזורי VIP פרטיים, שירות בקבוקים פרימיום, שירות מארח אישי",
      feature4Title: "DJ חי ומוזיקה",
      feature4Desc: "קונספט שונה כל לילה, הופעות DJ מקצועיות, רחבת ריקודים",
      ctaTitle: "בואו ל-First Lady Club",
      ctaDesc: "הזמינו שולחן VIP ללילה בלתי נשכח במועדון הלילה הטוב ביותר בקירניה. קו WhatsApp 24/7 פתוח.",
      ctaWhatsapp: "הזמנת שולחן",
      ctaCall: "התקשרו עכשיו",
      hours: "פתוח 24/7",
      seoText: "First Lady Club קירניה - מועדון הלילה #1 בצפון קפריסין. ריקוד על עמוד, מופעי סטריפטיז. הזמנת שולחן VIP. מועדון לילה קפריסין, מועדון קירניה, מקום בידור TRNC."
    },
    about: {
      subtitle: "אודות",
      title1: "FIRST LADY",
      title2: "ENTERTAINMENT",
      mainTitle: "מותג הבידור למבוגרים #1 בקפריסין",
      para1: "First Lady מספקת שירותי בידור למבוגרים מקצועיים בצפון קפריסין מאז 2014. אנחנו המותג המוביל בתחום עם שירותי מארחות ורקדניות למלונות, וילות ומגורים, ומופעי ריקוד על עמוד וסטריפטיז במקום שלנו בקירניה.",
      para2: "עם למעלה מ-50,000 אורחים מרוצים, דירוג ממוצע של 4.9/5 ולמעלה מ-90% שיעור חזרה, אנחנו שירות הבידור למבוגרים האמין ביותר בצפון קפריסין. אנחנו מספקים שירות מקצועי עם הבטחת פרטיות מלאה.",
      para3: "עם הצוות המקצועי שלנו, צי מרצדס ו-BMW יוקרתי, למעלה מ-10 שנות ניסיון, אנחנו מספקים שירות 24/7 לקירניה, ניקוסיה, פאמגוסטה וכל צפון קפריסין.",
      feature1: "פרטיות מלאה",
      feature2: "צוות מקצועי",
      feature3: "איכות פרימיום",
      feature4: "שירות 24/7",
      stat1: "שנות ניסיון",
      stat2: "אורחים מרוצים",
      stat3: "דירוג ממוצע",
      stat4: "שירות 24/7",
      established: "נוסד",
      seoText: "First Lady Entertainment - מותג הבידור למבוגרים המבוסס והאמין ביותר בצפון קפריסין. שירות מקצועי מאז 2014. מארחות, רקדניות, הסעות VIP, מועדון לילה."
    },
    contact: {
      subtitle: "צור קשר",
      title1: "התקשרו",
      title2: "עכשיו",
      description: "WhatsApp 24/7 למארחות, רקדניות, שירות מלון/וילה והסעות VIP",
      phone: "טלפון",
      location: "מיקום",
      locationValue: "קירניה, צפון קפריסין",
      hours: "שעות עבודה",
      hoursValue: "שירות 24/7",
      whatsappBtn: "שלחו הודעה בWhatsApp",
      supportTitle: "קו תמיכה 24/7",
      supportDesc: "הבטחת תגובה מיידית. שירות לקירניה, ניקוסיה, פאמגוסטה וכל צפון קפריסין!"
    },
    faq: {
      subtitle: "שאלות נפוצות",
      title1: "שאלות",
      title2: "נפוצות",
      description: "השאלות הנפוצות ביותר על השירותים שלנו",
      questions: [
        {
          q: "איך עובד שירות מלון ווילה בקפריסין?",
          a: "אנחנו שולחים מארחות ורקדניות מקצועיות לחדר המלון, וילה או מגורים שלכם בקירניה, ניקוסיה, פאמגוסטה וכל צפון קפריסין. שירות 24/7 עם הבטחת פרטיות מלאה. הזמנה דרך WhatsApp: +90 548 848 4828"
        },
        {
          q: "לאילו אזורים אתם נותנים שירות?",
          a: "אנחנו נותנים שירות לכל צפון קפריסין: קירניה (גירנה), ניקוסיה (לפקושה), פאמגוסטה (גזימגוסה), גוזליורט, קרפז וכל האזורים התיירותיים. הסעה לכל מקום עם הסעות VIP."
        },
        {
          q: "איפה First Lady Club, מה השעות?",
          a: "First Lady Club ממוקם במרכז קירניה. פתוח 24/7. אנחנו מציעים ריקוד על עמוד, מופעי סטריפטיז ושירות שולחן VIP."
        },
        {
          q: "מה מדיניות הפרטיות שלכם?",
          a: "פרטיות הלקוח היא העדיפות #1 שלנו. כל השירותים שלנו ניתנים עם הבטחת פרטיות מלאה. מידע על לקוחות לעולם לא משותף עם צדדים שלישיים."
        },
        {
          q: "איך אני יכול להזמין?",
          a: "הזמנה קלה ומהירה 24/7 דרך WhatsApp: +90 548 848 4828. מספר אחד לשירות מלון/וילה, הזמנת מקום והסעות VIP. הבטחת תגובה תוך 5 דקות."
        },
        {
          q: "אילו אמצעי תשלום אתם מקבלים?",
          a: "אנחנו מקבלים מזומן (לירה טורקית, אירו, דולר, שטרלינג) וכרטיס אשראי. התשלום נלקח לאחר השירות."
        },
        {
          q: "אתם יכולים לארגן רקדנית למסיבת רווקים?",
          a: "כן! אנחנו מספקים שירות רקדניות וריקודי בטן מקצועי למסיבות רווקים, ימי הולדת, מסיבות פרטיות וחגיגות. אנחנו מגיעים למלון, וילה, מגורים או מקום שלכם."
        },
        {
          q: "איך עובד שירות הסעות VIP?",
          a: "אנחנו אוספים אתכם משדה התעופה ארקאן, מלון או כתובת שצוינה עם רכבי מרצדס ו-BMW יוקרתיים. נהגים מקצועיים, שירות 24/7, רכבים מבוטחים."
        }
      ],
      moreQuestions: "יש עוד שאלות?",
      whatsappLink: "שלחו לנו הודעה בWhatsApp →"
    },
    footer: {
      description: "שירות הבידור למבוגרים #1 בצפון קפריסין. מארחות ורקדניות למלונות, וילות, מגורים. ריקוד על עמוד ומופעי סטריפטיז. הסעות VIP 24/7.",
      quickLinks: "קישורים מהירים",
      contact: "צור קשר",
      legal: "הצהרה משפטית",
      privacy: "מדיניות פרטיות",
      copyright: "כל הזכויות שמורות.",
      vipExperience: "שירותי בידור VIP"
    },
    floatingWhatsapp: {
      tooltip: "שלחו לנו הודעה!",
      defaultMessage: "שלום, הייתי רוצה מידע על השירותים שלכם."
    },
    legal: {
      pageTitle: "הצהרה משפטית",
      shortDisclaimer: "פלטפורמה זו מספקת שירותי סיוע בידור למבוגרים. כל השירותים מתבצעים בצורה חוקית, בין מבוגרים מסכימים בני 18 ומעלה. מידע באתר זה הוא למטרות פרסום בלבד.",
      fullDisclaimer: "אתר זה הוא פלטפורמה חוקית הפועלת בתחום הבידור למבוגרים. שירותי המארחות, רקדניות והסעות המוצעים מתבצעים בהתאם לחוקי הרפובליקה הטורקית של צפון קפריסין, בין מבוגרים מסכימים בני 18 ומעלה. הפלטפורמה לא תומכת או מעודדת כל פעילות בלתי חוקית. השירותים שלנו מיועדים רק לאנשים בני 18 ומעלה. על ידי שימוש בשירותים שלנו, המשתמשים מסכימים לתנאים אלה ומאשרים שהם מעל גיל 18. מידע על לקוחות מוגן על פי מדיניות הפרטיות שלנו.",
      backToHome: "חזרה לדף הבית"
    },
    testimonials: {
      subtitle: "ביקורות לקוחות",
      title1: "חוויות",
      title2: "לקוחות",
      description: "חוויות של 50,000+ אורחים מרוצים",
      reviews: [
        { name: "אחמד י.", location: "איסטנבול", text: "התקשרתי לשירות מלון בקירניה. צוות מקצועי להפליא. 10/10 על פרטיות ואיכות. מומלץ בחום." },
        { name: "מחמט ק.", location: "אנקרה", text: "קיבלתי שירות מארחות לוילה. מרוצה מאוד. First Lady היא באמת הטובה ביותר בקפריסין." },
        { name: "ג'אן ב.", location: "איזמיר", text: "קיבלתי שירות רקדנית למסיבת רווקים. זה היה לילה מדהים! מקצועי ומהנה." },
        { name: "אמרה ס.", location: "בורסה", text: "עשיתי הסעות VIP והזמנת מקום. הכל היה מושלם. שירות 5 כוכבים!" }
      ]
    },
    gallery: {
      subtitle: "גלריה",
      title1: "חוויית",
      title2: "VIP",
      description: "רגעים מהשירותים המקצועיים והמקום היוקרתי של First Lady"
    },
    whyChooseUs: {
      subtitle: "למה First Lady?",
      title1: "למה",
      title2: "FIRST LADY",
      features: [
        { title: "פרטיות מלאה", desc: "פרטיות הלקוח היא העדיפות #1 שלנו" },
        { title: "שירות 24/7", desc: "זמינים ביום ובלילה" },
        { title: "צוות מקצועי", desc: "צוות נבחר ומאומן" },
        { title: "תגובה תוך 5 דקות", desc: "הבטחת תגובה מיידית" }
      ]
    }
  },
  // KURDISH (KU) - Kurdî (Kurmancî)
  ku: {
    nav: {
      services: "XIZMET",
      venue: "CÎHÊ",
      about: "DERBARÊ",
      gallery: "GALERÎ",
      contact: "TÊKILÎ",
      reservation: "REZERVASYON"
    },
    media: {
      subtitle: "Galeriya Medyayê",
      title1: "WÊNE &",
      title2: "VÎDYO",
      desc: "Wêne û vîdyoyên taybetî ji First Lady Night Club",
      all: "Hemû",
      images: "Wêne",
      videos: "Vîdyo"
    },
    hero: {
      urgencyBanner: "Îşev Kapasîteya Sînordar!",
      location: "Gîrne • Kyrenia • Kuzey Kıbrıs",
      title1: "KONSOMATRİS",
      title2: "& DANSOZ",
      title3: "XIZMET",
      subtitle: "Xizmeta Şahiyê ya #1 ya Bakurê Kîprosê. Konsomatris û dansozên profesyonel ji bo otel, villa, rezîdans û mala we. Pole dance û striptease li Gîrneyê. Taksî û veguheztina VIP 24/7.",
      trustSignal1: "Puan 4.9/5",
      trustSignal2: "50,000+ Mêvan",
      trustSignal3: "10+ Sal Tecrûbe",
      feature1: "Xizmeta Otel/Villa",
      feature2: "Veguheztina VIP",
      feature3: "24/7 Vekirî",
      ctaWhatsapp: "Niha Rezerve Bike",
      ctaCall: "Niha Bipeyive",
      available: "WhatsApp & Têlefon 24/7",
      onlineNow: "Niha serhêl - garantiya bersivê di 5 deqeyan de",
      discover: "Keşf Bike"
    },
    services: {
      subtitle: "Xizmetên Premium",
      title1: "XIZMETÊN",
      title2: "VIP",
      description: "Xizmetên konsomatris, dansoz û veguheztina VIP ya taybetî ji bo otel, villa û rezîdansên li Bakurê Kîprosê. Xizmeta profesyonel bi garantiya nepenîtiya tevahî.",
      stat1: "Salên Tecrûbe",
      stat2: "Mêvanên Dilxweş",
      stat3: "Xizmeta Stêrkî",
      highlightedTitle: "Xizmeta Otel, Villa & Rezîdans",
      highlightedDesc: "Xizmeta otel, villa û rezîdansa herî prestîj a Bakurê Kîprosê. Konsomatris û dansoza taybetî ji bo cihê we. Şahiya profesyonel ji bo otela luksê, vîllaya taybetî an rezîdansa we. NEPENÎTİYA TEVAHÎ û EWLEKARÎ garantî. Xizmeta 24/7 ji bo Gîrne, Lefkoşa, Gazîmağusa û tevahiya Bakurê Kîprosê.",
      highlightedFeatures: ["Xizmeta Otel", "Xizmeta Villa", "Xizmeta Rezîdans", "Xizmeta Mal", "Xizmeta 24/7", "Nepenîtiya Tevahî"],
      mostPopular: "#1 Herî Populer",
      service1Title: "Xizmeta Konsomatris",
      service1Desc: "Konsomatrisên herî bijartî û profesyonel ên Kîprosê. Xizmeta VIP ya taybetî ji bo odeya otelê, vîlla an mala we. Xizmet ji bo Gîrne, Lefkoşa, Gazîmağusa. Garantiya nepenîtiya tevahî.",
      service1Features: ["Kadro Profesyonel", "Xizmeta Otel", "Xizmeta Villa", "Nepenîtiya Tevahî"],
      service2Title: "Dansoz & Oryantal",
      service2Desc: "Xizmeta dansoz û dansa oryantal a profesyonel. Ji bo partiyên bekarlığa veda, rojbûn, partiyên taybetî û pîrozbahiyan. Em tên otela we, vîlla, rezîdans an cihê we.",
      service2Features: ["Dansa Oryantal", "Partiya Bekarlığa Veda", "Rojbûn", "Partiya Taybetî"],
      service3Title: "Taksî & Veguheztina VIP",
      service3Desc: "Veguheztina VIP 24/7 bi wesayîtên Mercedes û BMW yên luks di navbera Balafirgeha Ercan, otel û ciyan de. Ajokarên profesyonel, wesayîtên sîgortekirî.",
      service3Features: ["Veguheztina Balafirgehê", "Veguheztina Otelê", "Wesayîtên Luks", "Xizmeta 24/7"],
      bookNow: "Niha Rezerve Bike",
      callNow: "Niha Bipeyive",
      seoText: "First Lady - Xizmeta şahiyê ya #1 ya Bakurê Kîprosê. Konsomatris û dansoz ji bo otel, villa û rezîdansên li Gîrne, Lefkoşa, Gazîmağusa. Veguheztina VIP ya profesyonel. 10+ sal tecrûbe, 50,000+ mêvanên dilxweş."
    },
    venue: {
      subtitle: "First Lady Club",
      title1: "KLUBA #1",
      title2: "A GİRNEYÊ",
      description: "Cihê şahiya mezinên herî prestîj ê Bakurê Kîprosê. Şowên pole dance yên profesyonel, performansên striptease û xizmeta maseya VIP. 5 deqe ji navenda Gîrneyê.",
      feature1Title: "Şowên Pole Dance",
      feature1Desc: "Performansên pole dance yên bêhnfireh ji hêla dansozên herî profesyonel ên Kîprosê",
      feature2Title: "Performansên Striptease",
      feature2Desc: "Şowên herî bi kalîte û profesyonel ên di şahiya mezin de",
      feature3Title: "Mase & Şûşe VIP",
      feature3Desc: "Qadên VIP yên taybetî, xizmeta şûşeyên premium, xizmeta host ya kesane",
      feature4Title: "DJ & Muzîka Zindî",
      feature4Desc: "Konseptên cuda her şev, performansên DJ yên profesyonel, qada dansê",
      ctaTitle: "Were First Lady Club",
      ctaDesc: "Ji bo şevek bîranînbar li kluba şevê ya herî baş a Gîrneyê rezervasyona maseya VIP bike. Xeta WhatsApp 24/7 vekiriye.",
      ctaWhatsapp: "Rezervasyona Maseyê",
      ctaCall: "Niha Bipeyive",
      hours: "24/7 Vekirî",
      seoText: "First Lady Club Gîrne - Kluba şevê ya #1 ya Bakurê Kîprosê. Pole dance, şowên striptease. Rezervasyona maseya VIP. Kluba şevê ya Kîprosê, kluba şevê ya Gîrneyê, cihê şahiya TRNC."
    },
    about: {
      subtitle: "Derbarê Me",
      title1: "FIRST LADY",
      title2: "ENTERTAINMENT",
      mainTitle: "Marka Şahiya Mezin a #1 ya Kîprosê",
      para1: "First Lady ji sala 2014 ve xizmetên şahiya mezin ên profesyonel li Bakurê Kîprosê pêşkêş dike. Em di sektora bi xizmetên konsomatris û dansoz ji bo otel, villa û rezîdansan, û şowên pole dance û striptease li cihê me li Gîrneyê markaya pêşeng in.",
      para2: "Bi zêdetirî 50,000 mêvanên dilxweş, puankirina navîn a 4.9/5 û rêjeya dubarebûnê ya ji %90 zêdetir, em xizmeta şahiya mezin a herî pêbawer a Bakurê Kîprosê ne. Em bi garantiya nepenîtiya tevahî xizmeta profesyonel pêşkêş dikin.",
      para3: "Bi ekîba me ya profesyonel, fîloya me ya luks a Mercedes û BMW, bi zêdetirî 10 sal tecrûbe, em xizmeta 24/7 ji bo Gîrne, Lefkoşa, Gazîmağusa û tevahiya Bakurê Kîprosê pêşkêş dikin.",
      feature1: "Nepenîtiya Tevahî",
      feature2: "Ekîba Profesyonel",
      feature3: "Kalîteya Premium",
      feature4: "Xizmeta 24/7",
      stat1: "Salên Tecrûbe",
      stat2: "Mêvanên Dilxweş",
      stat3: "Puankirina Navîn",
      stat4: "Xizmeta 24/7",
      established: "Damezrandî",
      seoText: "First Lady Entertainment - Markaya şahiya mezin a herî bingeh û pêbawer a Bakurê Kîprosê. Xizmeta profesyonel ji 2014 ve. Konsomatris, dansoz, veguheztina VIP, kluba şevê."
    },
    contact: {
      subtitle: "Têkilî",
      title1: "NIHA",
      title2: "BIPEYIVE",
      description: "WhatsApp 24/7 ji bo konsomatris, dansoz, xizmeta otel/villa û veguheztina VIP",
      phone: "Têlefon",
      location: "Cih",
      locationValue: "Gîrne, Bakurê Kîprûsê",
      hours: "Demên Xebatê",
      hoursValue: "Xizmeta 24/7",
      whatsappBtn: "Bi WhatsApp Binivîse",
      supportTitle: "Xeta Piştgiriyê 24/7",
      supportDesc: "Garantiya bersiva tavilê. Xizmet ji bo Gîrne, Lefkoşa, Gazîmağusa û tevahiya Bakurê Kîprosê!"
    },
    faq: {
      subtitle: "Pirsên Pir Pirsgirêk",
      title1: "PIRSÊN",
      title2: "HEVPAR",
      description: "Pirsên herî pir pirsên li ser xizmetên me",
      questions: [
        {
          q: "Xizmeta otel û villa li Kîprosê çawa dixebite?",
          a: "Em konsomatris û dansozên profesyonel ji bo odeya otelê, vîlla an rezîdansa we li Gîrne, Lefkoşa, Gazîmağusa û tevahiya Bakurê Kîprosê dişînin. Xizmeta 24/7 bi garantiya nepenîtiya tevahî. Bi WhatsApp rezerve bike: +90 548 848 4828"
        },
        {
          q: "Hûn ji kîjan herêman xizmet dikin?",
          a: "Em ji tevahiya Bakurê Kîprosê xizmet dikin: Gîrne (Kyrenia), Lefkoşa (Nicosia), Gazîmağusa (Famagusta), Güzelyurt, Karpaz û hemû herêmên geştiyariyê. Bi veguheztina VIP veguheztina li her derê."
        },
        {
          q: "First Lady Club li ku ye, demên xebatê çi ne?",
          a: "First Lady Club li navenda Gîrneyê ye. 24/7 vekiriye. Em pole dance, şowên striptease û xizmeta maseya VIP pêşkêş dikin."
        },
        {
          q: "Polîtîkaya nepenîtiyê ya we çi ye?",
          a: "Nepenîtiya xerîdar pêşîniya me ya #1 e. Hemû xizmetên me bi garantiya NEPENÎTİYA TEVAHÎ pêşkêş dibin. Agahdariya xerîdar qet bi aliyên sêyemîn re nayê parve kirin."
        },
        {
          q: "Ez çawa dikarim rezervasyonê bikim?",
          a: "Rezervasyona hêsan û bilez 24/7 bi WhatsApp: +90 548 848 4828. Ji bo xizmeta otel/villa, rezervasyona cih û veguheztina VIP hejmarek. Garantiya bersivê di 5 deqeyan de."
        },
        {
          q: "Kîjan rêbazên dravdanê qebûl dikin?",
          a: "Em drav (Lîraya Tirkî, Euro, Dolar, Sterlîn) û karta krediyê qebûl dikin. Drav piştî xizmetê tê girtin."
        },
        {
          q: "Hûn dikarin ji bo partiya bekarlığa veda dansozê amade bikin?",
          a: "Erê! Em xizmeta dansoz û dansa oryantal a profesyonel ji bo partiyên bekarlığa veda, rojbûn, partiyên taybetî û pîrozbahiyan pêşkêş dikin. Em tên otela we, vîlla, rezîdans an cihê we."
        },
        {
          q: "Xizmeta veguheztina VIP çawa dixebite?",
          a: "Em we ji Balafirgeha Ercan, otel an navnîşana hatî destnîşan kirin bi wesayîtên luks ên Mercedes û BMW hildigirin. Ajokarên profesyonel, xizmeta 24/7, wesayîtên sîgortekirî."
        }
      ],
      moreQuestions: "Pirsên din hene?",
      whatsappLink: "Bi WhatsApp ji me re binivîse →"
    },
    footer: {
      description: "Xizmeta şahiya mezin a #1 ya Bakurê Kîprosê. Konsomatris û dansoz ji bo otel, villa, rezîdans. Pole dance û şowên striptease. Veguheztina VIP 24/7.",
      quickLinks: "Lînkên Bilez",
      contact: "Têkilî",
      legal: "Hişyariya Qanûnî",
      privacy: "Polîtîkaya Nepenîtiyê",
      copyright: "Hemû maf parastî ne.",
      vipExperience: "Xizmetên Şahiya VIP"
    },
    floatingWhatsapp: {
      tooltip: "Niha Binivîse!",
      defaultMessage: "Silav, ez dixwazim agahdarî li ser xizmetên we bistînim."
    },
    legal: {
      pageTitle: "Hişyariya Qanûnî",
      shortDisclaimer: "Ev platform xizmetên alîkariya şahiya mezin pêşkêş dike. Hemû xizmet bi awayekî qanûnî, di navbera mezinên razî yên 18 sal û jor de pêk tên. Agahdariya li ser vê malperê tenê ji bo armancên danasînê ye.",
      fullDisclaimer: "Ev malper platformek qanûnî ye ku di sektora şahiya mezin de dixebite. Xizmetên konsomatris, dansoz û veguheztinê yên pêşkêşkirî li gorî qanûnên Komara Tirk a Bakurê Kîprosê, di navbera mezinên razî yên 18 sal û jor de pêk tên. Platform ti çalakiya neqanûnî piştgirî nake an teşwîq nake. Xizmetên me tenê ji bo kesên 18 sal û jor têne armanc kirin. Bi karanîna xizmetên me, bikarhêner van mercan qebûl dikin û piştrast dikin ku ew ji 18 salî mezintir in. Agahdariya xerîdar di bin polîtîkaya nepenîtiyê ya me de tê parastin.",
      backToHome: "Vegere Rûpela Sereke"
    },
    testimonials: {
      subtitle: "Nirxandinên Xerîdar",
      title1: "TECRÛBEYÊN",
      title2: "XERÎDARAN",
      description: "Tecrûbeyên 50,000+ mêvanên dilxweş",
      reviews: [
        { name: "Ahmet Y.", location: "Stenbol", text: "Ji bo xizmeta otelê li Gîrneyê bang kir. Ekîbek bêhempa profesyonel. 10/10 ji bo nepenîtî û kalîte. Bi zorê pêşniyar dikim." },
        { name: "Mehmet K.", location: "Ankara", text: "Ji bo vîlla xizmeta konsomatris girt. Pir razî ma. First Lady bi rastî ya herî baş a Kîprosê ye." },
        { name: "Can B.", location: "Îzmîr", text: "Ji bo partiya bekarlığa veda xizmeta dansoz girt. Şevek ecêb bû! Profesyonel û kêfxweş." },
        { name: "Emre S.", location: "Bursa", text: "Veguheztina VIP û rezervasyona cih kir. Her tişt bêkêmasî bû. Xizmeta 5 stêrk!" }
      ]
    },
    gallery: {
      subtitle: "Galerî",
      title1: "TECRÛBEYA",
      title2: "VIP",
      description: "Kêliyên ji xizmetên profesyonel û cihê luks ê First Lady"
    },
    whyChooseUs: {
      subtitle: "Çima First Lady?",
      title1: "ÇIMA",
      title2: "FIRST LADY",
      features: [
        { title: "Nepenîtiya Tevahî", desc: "Nepenîtiya xerîdar pêşîniya me ya #1 e" },
        { title: "Xizmeta 24/7", desc: "Bi şev û roj li ber destê we" },
        { title: "Ekîba Profesyonel", desc: "Karmendan bijartî û rahênerkirî" },
        { title: "Bersiv di 5 Deq", desc: "Garantiya bersiva tavilê" }
      ]
    }
  },
  // ARABIC (AR) - العربية
  ar: {
    nav: {
      services: "الخدمات",
      venue: "النادي",
      about: "من نحن",
      gallery: "المعرض",
      contact: "اتصل بنا",
      reservation: "حجز"
    },
    media: {
      subtitle: "معرض الوسائط",
      title1: "صور &",
      title2: "فيديوهات",
      desc: "صور وفيديوهات حصرية من First Lady Night Club",
      all: "الكل",
      images: "صور",
      videos: "فيديو"
    },
    hero: {
      urgencyBanner: "سعة محدودة الليلة!",
      location: "كيرينيا • غيرنه • شمال قبرص",
      title1: "مضيفات",
      title2: "وراقصات",
      title3: "خدمات",
      subtitle: "خدمة الترفيه للبالغين رقم 1 في شمال قبرص. مضيفات وراقصات محترفات إلى فندقك، فيلتك، إقامتك. عروض رقص القطب والستريبتيز في كيرينيا. سيارات أجرة VIP ونقل 24/7.",
      trustSignal1: "تقييم 4.9/5",
      trustSignal2: "50,000+ ضيف",
      trustSignal3: "10+ سنوات خبرة",
      feature1: "خدمة فندق/فيلا",
      feature2: "نقل VIP",
      feature3: "مفتوح 24/7",
      ctaWhatsapp: "احجز الآن",
      ctaCall: "اتصل الآن",
      available: "واتساب وهاتف 24/7",
      onlineNow: "متصل الآن - ضمان الرد في 5 دقائق",
      discover: "اكتشف"
    },
    services: {
      subtitle: "خدمات بريميوم",
      title1: "خدمات",
      title2: "VIP",
      description: "خدمات مضيفات وراقصات ونقل VIP خاصة للفنادق والفلل والإقامات في شمال قبرص. خدمة احترافية مع ضمان الخصوصية الكاملة.",
      stat1: "سنوات الخبرة",
      stat2: "ضيوف سعداء",
      stat3: "خدمة نجمية",
      highlightedTitle: "خدمة فندق وفيلا وإقامة",
      highlightedDesc: "أفخم خدمة فنادق وفلل وإقامات في شمال قبرص. مضيفات وراقصات خاصة إلى موقعك. ترفيه احترافي لفندقك الفاخر أو فيلتك الخاصة أو إقامتك. خصوصية وأمان كاملان مضمونان. خدمة 24/7 لكيرينيا، نيقوسيا، فاماغوستا وكل شمال قبرص.",
      highlightedFeatures: ["خدمة فندق", "خدمة فيلا", "خدمة إقامة", "خدمة منزلية", "خدمة 24/7", "خصوصية كاملة"],
      mostPopular: "#1 الأكثر شعبية",
      service1Title: "خدمة المضيفات",
      service1Desc: "أفضل وأكثر المضيفات احترافية في قبرص. خدمة VIP خاصة لغرفة فندقك أو فيلتك أو منزلك. خدمة لكيرينيا، نيقوسيا، فاماغوستا. ضمان خصوصية كاملة.",
      service1Features: ["فريق محترف", "خدمة فندق", "خدمة فيلا", "خصوصية كاملة"],
      service2Title: "راقصات ورقص شرقي",
      service2Desc: "خدمة راقصات ورقص شرقي احترافية. لحفلات العزوبية، أعياد الميلاد، الحفلات الخاصة والاحتفالات. نأتي إلى فندقك، فيلتك، إقامتك أو مكانك.",
      service2Features: ["رقص شرقي", "حفلة عزوبية", "عيد ميلاد", "حفلة خاصة"],
      service3Title: "سيارة أجرة ونقل VIP",
      service3Desc: "نقل VIP 24/7 بسيارات مرسيدس وBMW فاخرة بين مطار إركان والفنادق والأماكن. سائقون محترفون، سيارات مؤمنة.",
      service3Features: ["نقل من المطار", "نقل من الفندق", "سيارات فاخرة", "خدمة 24/7"],
      bookNow: "احجز الآن",
      callNow: "اتصل الآن",
      seoText: "First Lady - خدمة الترفيه للبالغين رقم 1 في شمال قبرص. مضيفات وراقصات للفنادق والفلل والإقامات في كيرينيا، نيقوسيا، فاماغوستا. نقل VIP احترافي. 10+ سنوات خبرة، 50,000+ ضيف سعيد."
    },
    venue: {
      subtitle: "First Lady Club",
      title1: "النادي #1",
      title2: "في كيرينيا",
      description: "أفخم مكان ترفيه للبالغين في شمال قبرص. عروض رقص القطب الاحترافية، عروض الستريبتيز وخدمة طاولة VIP. 5 دقائق من مركز كيرينيا.",
      feature1Title: "عروض رقص القطب",
      feature1Desc: "عروض رقص قطب مذهلة من أكثر الراقصات احترافية في قبرص",
      feature2Title: "عروض الستريبتيز",
      feature2Desc: "أعلى جودة وأكثر العروض احترافية في الترفيه للبالغين",
      feature3Title: "طاولة وزجاجة VIP",
      feature3Desc: "مناطق VIP خاصة، خدمة زجاجات بريميوم، خدمة مضيف شخصي",
      feature4Title: "DJ حي وموسيقى",
      feature4Desc: "مفهوم مختلف كل ليلة، عروض DJ احترافية، حلبة رقص",
      ctaTitle: "تعال إلى First Lady Club",
      ctaDesc: "احجز طاولة VIP لليلة لا تُنسى في أفضل نادي ليلي في كيرينيا. خط واتساب 24/7 مفتوح.",
      ctaWhatsapp: "حجز طاولة",
      ctaCall: "اتصل الآن",
      hours: "مفتوح 24/7",
      seoText: "First Lady Club كيرينيا - النادي الليلي رقم 1 في شمال قبرص. رقص القطب، عروض الستريبتيز. حجز طاولة VIP. نادي ليلي قبرص، نادي كيرينيا، مكان ترفيه TRNC."
    },
    about: {
      subtitle: "من نحن",
      title1: "FIRST LADY",
      title2: "ENTERTAINMENT",
      mainTitle: "العلامة التجارية رقم 1 للترفيه للبالغين في قبرص",
      para1: "First Lady تقدم خدمات ترفيه للبالغين احترافية في شمال قبرص منذ 2014. نحن العلامة التجارية الرائدة في القطاع مع خدمات المضيفات والراقصات للفنادق والفلل والإقامات، وعروض رقص القطب والستريبتيز في مكاننا في كيرينيا.",
      para2: "مع أكثر من 50,000 ضيف سعيد، متوسط تقييم 4.9/5 ومعدل تكرار أكثر من 90%، نحن أكثر خدمة ترفيه للبالغين موثوقية في شمال قبرص. نقدم خدمة احترافية مع ضمان خصوصية كاملة.",
      para3: "مع فريقنا المحترف، أسطولنا الفاخر من مرسيدس وBMW، أكثر من 10 سنوات خبرة، نقدم خدمة 24/7 لكيرينيا، نيقوسيا، فاماغوستا وكل شمال قبرص.",
      feature1: "خصوصية كاملة",
      feature2: "فريق محترف",
      feature3: "جودة بريميوم",
      feature4: "خدمة 24/7",
      stat1: "سنوات الخبرة",
      stat2: "ضيوف سعداء",
      stat3: "متوسط التقييم",
      stat4: "خدمة 24/7",
      established: "تأسست",
      seoText: "First Lady Entertainment - أكثر علامة تجارية للترفيه للبالغين رسوخاً وموثوقية في شمال قبرص. خدمة احترافية منذ 2014. مضيفات، راقصات، نقل VIP، نادي ليلي."
    },
    contact: {
      subtitle: "اتصل بنا",
      title1: "اتصل",
      title2: "الآن",
      description: "واتساب 24/7 للمضيفات، الراقصات، خدمة فندق/فيلا ونقل VIP",
      phone: "هاتف",
      location: "الموقع",
      locationValue: "كيرينيا، شمال قبرص",
      hours: "ساعات العمل",
      hoursValue: "خدمة 24/7",
      whatsappBtn: "راسل على واتساب",
      supportTitle: "خط دعم 24/7",
      supportDesc: "ضمان رد فوري. خدمة لكيرينيا، نيقوسيا، فاماغوستا وكل شمال قبرص!"
    },
    faq: {
      subtitle: "الأسئلة الشائعة",
      title1: "أسئلة",
      title2: "شائعة",
      description: "الأسئلة الأكثر شيوعاً حول خدماتنا",
      questions: [
        {
          q: "كيف تعمل خدمة الفندق والفيلا في قبرص؟",
          a: "نرسل مضيفات وراقصات محترفات إلى غرفة فندقك أو فيلتك أو إقامتك في كيرينيا، نيقوسيا، فاماغوستا وكل شمال قبرص. خدمة 24/7 مع ضمان خصوصية كاملة. احجز عبر واتساب: +90 548 848 4828"
        },
        {
          q: "أي مناطق تخدمون؟",
          a: "نخدم كل شمال قبرص: كيرينيا (غيرنه)، نيقوسيا (لفكوشا)، فاماغوستا (غازي ماغوسا)، غوزليورت، كارباز وكل المناطق السياحية. نقل إلى أي مكان مع نقل VIP."
        },
        {
          q: "أين First Lady Club، ما هي الساعات؟",
          a: "First Lady Club يقع في مركز كيرينيا. مفتوح 24/7. نقدم رقص القطب، عروض الستريبتيز وخدمة طاولة VIP."
        },
        {
          q: "ما هي سياسة الخصوصية الخاصة بكم؟",
          a: "خصوصية العميل هي أولويتنا رقم 1. كل خدماتنا تُقدم مع ضمان خصوصية كاملة. معلومات العميل لا تُشارك أبداً مع أطراف ثالثة."
        },
        {
          q: "كيف يمكنني الحجز؟",
          a: "حجز سهل وسريع 24/7 عبر واتساب: +90 548 848 4828. رقم واحد لخدمة فندق/فيلا، حجز مكان ونقل VIP. ضمان رد في 5 دقائق."
        },
        {
          q: "أي طرق دفع تقبلون؟",
          a: "نقبل نقداً (ليرة تركية، يورو، دولار، جنيه إسترليني) وبطاقة ائتمان. الدفع يُؤخذ بعد الخدمة."
        },
        {
          q: "هل يمكنكم ترتيب راقصة لحفلة عزوبية؟",
          a: "نعم! نقدم خدمة راقصات ورقص شرقي احترافية لحفلات العزوبية، أعياد الميلاد، الحفلات الخاصة والاحتفالات. نأتي إلى فندقك، فيلتك، إقامتك أو مكانك."
        },
        {
          q: "كيف تعمل خدمة نقل VIP؟",
          a: "نأخذك من مطار إركان، الفندق أو العنوان المحدد بسيارات مرسيدس وBMW فاخرة. سائقون محترفون، خدمة 24/7، سيارات مؤمنة."
        }
      ],
      moreQuestions: "هل لديك أسئلة أخرى؟",
      whatsappLink: "راسلنا على واتساب →"
    },
    footer: {
      description: "خدمة الترفيه للبالغين رقم 1 في شمال قبرص. مضيفات وراقصات للفنادق والفلل والإقامات. رقص القطب وعروض الستريبتيز. نقل VIP 24/7.",
      quickLinks: "روابط سريعة",
      contact: "اتصل بنا",
      legal: "إخلاء المسؤولية القانونية",
      privacy: "سياسة الخصوصية",
      copyright: "جميع الحقوق محفوظة.",
      vipExperience: "خدمات ترفيه VIP"
    },
    floatingWhatsapp: {
      tooltip: "راسلنا الآن!",
      defaultMessage: "مرحباً، أريد معلومات عن خدماتكم."
    },
    legal: {
      pageTitle: "إخلاء المسؤولية القانونية",
      shortDisclaimer: "هذه المنصة تقدم خدمات مساعدة ترفيه للبالغين. كل الخدمات تُجرى بشكل قانوني، بين بالغين راضين فوق 18 سنة. المعلومات على هذا الموقع لأغراض ترويجية فقط.",
      fullDisclaimer: "هذا الموقع منصة قانونية تعمل في قطاع الترفيه للبالغين. خدمات المضيفات والراقصات والنقل المقدمة تُجرى وفقاً لقوانين جمهورية شمال قبرص التركية، بين بالغين راضين فوق 18 سنة. المنصة لا تدعم أو تشجع أي نشاط غير قانوني. خدماتنا مخصصة فقط للأشخاص فوق 18 سنة. باستخدام خدماتنا، يوافق المستخدمون على هذه الشروط ويؤكدون أنهم فوق 18 سنة. معلومات العميل محمية بموجب سياسة الخصوصية الخاصة بنا.",
      backToHome: "العودة للصفحة الرئيسية"
    },
    testimonials: {
      subtitle: "آراء العملاء",
      title1: "تجارب",
      title2: "العملاء",
      description: "تجارب 50,000+ ضيف سعيد",
      reviews: [
        { name: "أحمد ي.", location: "إسطنبول", text: "اتصلت لخدمة فندق في كيرينيا. فريق محترف بشكل لا يصدق. 10/10 للخصوصية والجودة. أوصي بشدة." },
        { name: "محمد ك.", location: "أنقرة", text: "حصلت على خدمة مضيفات للفيلا. راضٍ جداً. First Lady حقاً الأفضل في قبرص." },
        { name: "جان ب.", location: "إزمير", text: "حصلت على خدمة راقصة لحفلة عزوبية. كانت ليلة رائعة! محترف وممتع." },
        { name: "عمرو س.", location: "بورصة", text: "قمت بنقل VIP وحجز مكان. كل شيء كان مثالياً. خدمة 5 نجوم!" }
      ]
    },
    gallery: {
      subtitle: "المعرض",
      title1: "تجربة",
      title2: "VIP",
      description: "لحظات من خدمات First Lady الاحترافية والمكان الفاخر"
    },
    whyChooseUs: {
      subtitle: "لماذا First Lady؟",
      title1: "لماذا",
      title2: "FIRST LADY",
      features: [
        { title: "خصوصية كاملة", desc: "خصوصية العميل أولويتنا رقم 1" },
        { title: "خدمة 24/7", desc: "متاحون ليلاً ونهاراً" },
        { title: "فريق محترف", desc: "فريق مختار ومدرب" },
        { title: "رد في 5 دقائق", desc: "ضمان رد فوري" }
      ]
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("language") || "tr";
    }
    return "tr";
  });

  useEffect(() => {
    localStorage.setItem("language", language);
    document.documentElement.lang = language;
    // Set RTL direction for Arabic and Hebrew
    document.documentElement.dir = (language === "ar" || language === "he") ? "rtl" : "ltr";
  }, [language]);

  const t = (key) => {
    const keys = key.split(".");
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "tr" ? "en" : "tr"));
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
